import React, { useMemo } from 'react';
import styled from 'styled-components';
import { ScoreHistory } from '../../../services/reportsRecapGet';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 24px;
  background: linear-gradient(to top, #ffffff, #abddffff);
  text-align: center;
`;

const Title = styled.h2`
  color: #1e3a8a;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 32px;
  line-height: 1.3;
`;

const ArchetypeIcon = styled.div`
  font-size: 64px;
  margin-bottom: 24px;
  animation: bounce 2s infinite;

  @keyframes bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  }
`;

const ArchetypeName = styled.h3`
  color: #2563eb;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 16px;
  padding: 8px 16px;
  background: #eff6ff;
  border-radius: 20px;
  display: inline-block;
`;

const Description = styled.p`
  color: #475569;
  font-size: 16px;
  line-height: 1.6;
  max-width: 320px;
  margin: 0 auto;
`;

interface Props {
    scoreHistory: ScoreHistory;
}

const PersonalitySlide: React.FC<Props> = ({ scoreHistory }) => {
    const { currentScore, archetype } = useMemo(() => {
        const scores = scoreHistory && scoreHistory.puntajes ? scoreHistory.puntajes : [];
        if (!scores || scores.length === 0) {
            return { currentScore: 0, archetype: "explorador" };
        }

        const sortedScores = [...scores].sort((a, b) => new Date(a.fecha).getTime() - new Date(b.fecha).getTime());

        const current = sortedScores[sortedScores.length - 1].puntaje;

        let type = "explorador";

        if (current >= 780) {
            type = "arquitecto";
        } else if (current >= 740 && current <= 779) {
            type = "guardian";
        } else if (current >= 520 && current <= 739) {
            type = "ascendente";
        } else {
            type = "explorador";
        }

        return { currentScore: current, archetype: type };
    }, [scoreHistory]);

    const renderContent = () => {
        switch (archetype) {
            case "arquitecto":
                return (
                    <>
                        <ArchetypeIcon>🏗️</ArchetypeIcon>
                        <ArchetypeName>Arquitecto Financiero</ArchetypeName>
                        <Description>
                            La estabilidad es uno de los mayores logros en las finanzas, refleja tus buenos hábitos. ¡Excelente!
                        </Description>
                    </>
                );
            case "guardian":
                return (
                    <>
                        <ArchetypeIcon>🛡️</ArchetypeIcon>
                        <ArchetypeName>Guardián del Score</ArchetypeName>
                        <Description>
                            Tu monitoreo constante demuestra compromiso con tu bienestar financiero.<br /><br /> Estar atento a tu score es una de las mejores decisiones para tu futuro.
                        </Description>
                    </>
                );
            case "ascendente":
                return (
                    <>
                        <ArchetypeIcon>📈</ArchetypeIcon>
                        <ArchetypeName>Ascendente</ArchetypeName>
                        <Description>
                            Este año recuperaste terreno, cada mejora cuenta. Tomaste acciones que impactaron positivamente tu historial. <br /><br />Eso demuestra disciplina y compromiso ¡Bien hecho!
                        </Description>
                    </>
                );
            case "explorador":
            default:
                if (!scoreHistory || !scoreHistory.puntajes || scoreHistory.puntajes.length === 0) {
                    return (
                        <>
                            <ArchetypeIcon>🔍</ArchetypeIcon>
                            <ArchetypeName>Explorador Financiero</ArchetypeName>
                            <Description>
                                Tu historia financiera se quedó en pausa. Te registraste para mejorar, pero aún no has visto qué hay detrás de tu puntaje.<br /><br />
                                <strong>¡No dejes que el 2026 te encuentre a ciegas, descubre hoy mismo qué puertas puedes abrir!</strong>
                            </Description>
                        </>
                    );
                }
                return (
                    <>
                        <ArchetypeIcon>🔍</ArchetypeIcon>
                        <ArchetypeName>Explorador Financiero</ArchetypeName>
                        <Description>
                            Este año empezaste a tomar control de tu información financiera.<br /><br /> <strong>¡Ese es un gran primer paso!</strong> Con cada revisión de tu información construyes claridad y mejores oportunidades financieras.
                        </Description>
                    </>
                );
        }
    };

    return (
        <Container>
            <Title>ARQUETIPO DE PERSONALIDAD FINANCIERA</Title>
            {renderContent()}
        </Container>
    );
};

export default PersonalitySlide;
